import React from 'react'
import { use, api } from 'xadmin'
import { ModelSelectField, ModelSelectMultip } from '../components/ModelSelect'

const ModelSelectComponent = (props) => {

  const { input, field, placeholder, defaultValue, multiple } = props
  const [ value, setValue ] = React.useState(input.value || defaultValue)

  React.useEffect(() => {
    input.onChange(defaultValue || {})
  }, [defaultValue])

  const onChange = (item) => {
    setValue(item)
    input.onChange(item)
  }

  return (
    <div>
      {multiple ? 
      <ModelSelectMultip  {...props} input={{...input, value: value instanceof Array ? value : value ? [value] : [], onChange}} field={{...field, placeholder}} /> :
      <ModelSelectField {...props} input={{...input, value, onChange}} field={{...field, placeholder}} />}
    </div>
  )
}

const paramSchema = {
  type: 'object',
  properties: {
    multiple: {
      type: 'boolean',
      title: '多选',
    },
    placeholder: {
      title: '提示文字',
      type: 'string',
      description: '选择器中的提示文本信息'
    }
  }
}

const ModelSelect = {
  title: '模型选择器',
  category: '业务选择器',
  icon: require('../icon/模型选择器.svg'),
  component: ModelSelectComponent,
  paramSchema: paramSchema,
  fieldWidget: true,
  initParam: { placeholder: '请选择模型' },
  initLayout: { width: 160, height: 40 },
  theme: [
    { selector: '.ant-select .ant-select-selector', title: '选择器样式' }
  ]
}

export default ModelSelect
